<template>
  <base-modal :formTitle="formTitle">
    <template v-slot:body>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-model="cor.descricao"
            :rules="[
              () => !!cor.descricao || 'Esse campo é obrigatório!',
            ]"
            ref="descricao"
            label="Descrição"
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:buttons>
      <buttons-cadastro @close="close" @save="save" />
    </template>
  </base-modal>
</template>
<script>
import { mapActions } from 'vuex'
import BaseModal from '@/components/BaseModal/BaseModal.vue'
import ButtonsCadastro from '@/components/ButtonsCadastro/ButtonsCadastro.vue'

export default {
  components: { BaseModal, ButtonsCadastro },
  name: 'CadastroCor',
  props: {
    cor: Object,
    formTitle: String,
    corIndex: Number,
  },

  data() {
    return {
      formError: false,
      defaultItem: {
        descricao: '',
      },
    }
  },

  computed: {
    form() {
      return {
        descricao: this.cor.descricao,
      }
    },
  },

  methods: {
    ...mapActions('patio', [
      'addCor',
      'editCor',
      'deleteCor',
    ]),

    close() {
      this.formError = false
      setTimeout(() => {
        Object.assign(this.cor, this.defaultItem)
        this.resetarFormulario()
      }, 300)

      this.$emit('close')
    },

    resetarFormulario() {
      this.formError = false

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].reset()
      })
    },

    verificaFormulario() {
      this.formError = false

      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) this.formError = true

        this.$refs[f].validate(!this.form[f])
      })
    },

    save() {
      this.verificaFormulario()
      if (this.formError) return

      if (this.corIndex > -1) {
        this.editCor(this.cor)
      } else {
        this.addCor(this.cor)
      }

      this.close()
    },
  },
}
</script>
<style>
</style>